import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Input, Label, Button, Badge } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kgbService"

import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from "../Blocs/IndexBloc"
import apiResponse from '../../../../../services/apiResponse'

import moment from 'moment'

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();

  source
  historyTable = 'KGBEmpTableActive'
  defaultOrder = 'sort'
  defaultSize = 10
  defaultSort = 'asc'
  configDatatable = {
    ...config('datatable'),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort
    }
  }

  modal_confirm_status = 0
  modal_confirm_message = ""
  modal_confirm_sucess_message = "data berhasil diproses"
  modal_confirm_error_message = "data gagal diproses"

  constructor(props) {
    super(props)
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable) ?
        JSON.parse(sessionStorage.getItem(this.historyTable)) :
        {
          filter_value: "",
          page_number: 1,
          page_size: this.defaultSize,
          sort_order: {
            column: this.defaultOrder,
            order: this.defaultSort
          }
        },
      dataSelected: [],
      checkAll: false
    }
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format('DD/MM/YYYY')
    }
    return res;
  }

  rupiah = (num) => {
    let res = "-";
    if (num != null && num != '') {
      res = parseFloat(num).toLocaleString('id-ID', { maximumFractionDigits: 2 })
    }
    return res;
  }

  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [
          ...this.state.dataSelected,
          uuid
        ]
      })
    } else {
      var filteredAry = this.state.dataSelected.filter(e => e !== uuid)
      this.setState({
        dataSelected: filteredAry
      })
    }
    console.log(uuid, checked);
  }

  handleButtonProcess = () => {
    console.log(this.state.dataSelected)
    this.modal_confirm_message = "Apakah anda yakin akan memproses data terpilih?"
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true
    })
  }
  handleButtonGenerate = () => {
    this.modal_confirm_message = "Apakah anda yakin generate ulang Rekomendasi?"
    this.modal_confirm_status = 2;
    this.setState({
      confirm: true
    })
  }

  handleButtonExportUsulan = () => {
    this.indexBloc.fetchExportUsulan({
      period_uuid: this.props.uuid,
    });
  }

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].kgb_temp_id
      let thisUuid = this.state.rows[i].kgb_temp_uuid
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      })
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected
    })
  }

  resetTable = () => {
    this.setState({
      dataSelected: []
    })
  }

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

    /* kirim ke server */
    let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size
      })
      offset = 0
      this.configDatatable.page_number = 1
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      period_uuid: this.props.uuid,
      is_process: 0
    }
    await this.dataTableBloc.fetchRowTable(query, this.source.token)
  }

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken()
    this.loadData()
  }

  confirmResponse = (response) => {
    let forState = {}
    switch (response) {
      case 'cancel':
        forState = {
          confirm: false
        }
        break;
      case 'confirm':
        forState = {
          loading: true,
          confirm: false
        }
        let data_status = parseInt(this.modal_confirm_status)
        if (data_status === 1) {
          let formData = {
            kgb_temp_uuids: this.state.dataSelected
          }
          this.indexBloc.fetchProcess(formData)
        } else if (data_status === 2) {
          let formData = {
            uuid: this.props.uuid
          }
          this.indexBloc.fetchGenerate(formData)

        } else {
          this.activeData()
        }
        break;
      case 'success':
        forState = {
          success: false,
          redirect: true
        }
        break;
      case 'failed':
        forState = {
          failed: false
        }
        break;
      default:
    }
    this.setState(forState)
  }

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
  }

  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid })
  }

  componentDidMount() {
    this.setTokenAPI()

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false
          })
          break
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true
          })
          break
        case apiResponse.COMPLETED:
          const response = result.data.response

          // set state for every checkbox
          for (let i = 0; i < response.result.length; i++) {
            let thisId = response.result[i].kgb_temp_id
            this.setState({
              [`check${thisId}`]: false
            })
          }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false
          })
          break
        case apiResponse.ERROR:

          break
        default:
          break
      }
    })

    this.indexBloc.exportUsulanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          })
          break
        case apiResponse.COMPLETED:
          const link = result.data.response
          window.open(link.file_url, "_blank")
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true
          })
          setTimeout(() => {
            this.setState({
              success: false,
            })
          }, 1000);
          break
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true
          })
          setTimeout(function () {
            this.setState({
              failed: false,
            })
          }, 1000)
          break
        default:
          break
      }
    })

    this.indexBloc.processChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:

          if (result.data.status) {
            this.setState({
              loading: false,
              success: true
            }, function () {
              this.setTokenAPI()
              this.resetTable()
              this.props.handleProcessSuccess()
            });
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true
            });
          }

          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    })
    this.indexBloc.generateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:

          if (result.data.status) {
            this.setState({
              loading: false,
              success: true
            }, function () {
              this.setTokenAPI()
              this.resetTable()
              //this.props.handleInactiveSuccess();
            });
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true
            });
          }

          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    });
  }
  

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe()
    this.indexBloc.exportUsulanChannel.unsubscribe()
    this.indexBloc.processChannel.unsubscribe()
  }

  columns = [
    {
      key: "kgb_temp_id",
      text: "Pilih",
      className: "kgb_temp_id",
      sortable: false,
      header: () => {
        return (
          <div className="form-check text-center font-size-16">
            <Input
              className="form-check-input"
              type="checkbox"
              name="checkAll"
              value=""
              checked={this.state.checkAll}
              onChange={(event) => {
                this.handleCheckAll(event)
              }}
            />
          </div>
        )
      },
      cell: record => {
        const thisId = record.kgb_temp_id
        return (
          <div className="form-check text-center font-size-16">
            <Input
              type="checkbox"
              className="form-check-input"
              id={'checkbox' + thisId}
              onChange={
                (event) => {
                  this.handleChecked(event, record.kgb_temp_uuid)
                  this.setState({
                    [`check${thisId}`]: !this.state[`check${thisId}`]
                  })
                }
              }
              checked={this.state[`check${thisId}`]}
            />
          </div>
        )
      }
    },
    {
      key: "employee_full_name",
      text: "Pegawai",
      className: "employee_full_name",
      sortable: true,
      cell: record => {
        return (
          <>
            <b>{record.kgb_temp_employee_name}</b>
            <div>{record.kgb_temp_employee_nip}</div>
            <div>{record.kgb_temp_tempat_lahir}, {this.dateParse(record.kgb_temp_tanggal_lahir)}</div>
          </>
        )
      }
    },
    {
      key: "kgb_temp_golongan_ruang",
      text: "Golongan/Ruang",
      className: "kgb_temp_golongan_ruang",
      sortable: true,
    },
    {
      key: "kgb_temp_sk_lama",
      text: "SK Lama",
      className: "kgb_temp_sk_lama",
      sortable: true,
      cell: record => {
        return (
          <>
            <b>{record.kgb_temp_sk_lama}</b>
            <div>{this.dateParse(record.kgb_temp_tanggal_sk_lama)}</div>
          </>
        )
      }
    },
    {
      key: "kgb_temp_masa_kerja_tahun_lama",
      text: "Masa Kerja Lama",
      className: "kgb_temp_masa_kerja_tahun_lama",
      sortable: true,
      cell: record => {
        return (
          <>
            <b>{record.kgb_temp_masa_kerja_tahun_lama} Tahun</b>
            <div>{record.kgb_temp_masa_kerja_bulan_lama} Bulan</div>
          </>
        )
      }
    },
    {
      key: "kgb_temp_gaji_pokok_lama",
      text: "Gaji Lama",
      className: "kgb_temp_gaji_pokok_lama",
      sortable: true,
      cell: record => {
        return this.rupiah(record.kgb_temp_gaji_pokok_lama);
      }
    },
    {
      key: "kgb_temp_tmt_lama",
      text: "TMT Lama",
      className: "kgb_temp_tmt_lama",
      sortable: true,
      cell: record => {
        return this.dateParse(record.kgb_temp_tmt_lama);
      }
    },
    {
      key: "kgb_temp_masa_kerja_tahun",
      text: "Masa Kerja Baru",
      className: "kgb_temp_masa_kerja_tahun",
      sortable: true,
      cell: record => {
        return (
          <>
            <b>{record.kgb_temp_masa_kerja_tahun} Tahun</b>
            <div>{record.kgb_temp_masa_kerja_bulan} Bulan</div>
          </>
        )
      }
    },
    {
      key: "kgb_temp_gaji_pokok_baru",
      text: "Gaji Baru",
      className: "kgb_temp_gaji_pokok_baru",
      sortable: true,
      cell: record => {
        return this.rupiah(record.kgb_temp_gaji_pokok_baru);
      }
    },
    // {
    //   key: "kgb_period_status",
    //   text: "Status",
    //   className: "kgb_period_status",
    //   sortable: true,
    //   width: '100',
    //   cell: record => {
    //     let status = parseInt(record.kgb_status);
    //     if (status == -1) {
    //       status = (
    //         <label className="badge rounded-pill bg-soft-info font-size-12">
    //           Rekomendasi
    //         </label>
    //       );
    //     } else if (status == 0) {
    //       status = (
    //         <label className="badge rounded-pill bg-soft-success font-size-12">
    //           Menunggu Proses
    //         </label>
    //       );
    //     } else if (status == 1) {
    //       status = (
    //         <label className="badge rounded-pill bg-soft-success font-size-12">
    //           Disetujui
    //         </label>
    //       );
    //     } else if (status == 2) {
    //       status = (
    //         <label className="badge rounded-pill bg-soft-error font-size-12">
    //           Ditolak
    //         </label>
    //       );
    //     }
    //     return <span> {status} </span>;
    //   }
    // },
    // {
    //     key: "action",
    //     text: "Action",
    //     className: "action",
    //     width: 120,
    //     sortable: false,
    //     align: 'center',
    //     cell: record => {
    //         const thisId = record.kgb_temp_id
    //         var  status = record.kgb_temp_uuid
    //         return (
    //             <Fragment>
    //                 <span>
    //                     <button
    //                         className="btn btn-primary btn-sm"
    //                         id={"detail-" + thisId}
    //                         onClick={() => {
    //                             this.setState({
    //                                 detailUuid: record.kgb_temp_uuid
    //                             })
    //                         }}
    //                         style={{
    //                             marginRight: '2px',
    //                             padding: '2px 5px'
    //                         }}>
    //                             <i className="uil-align-left"></i>
    //                     </button>
    //                     <Tooltip
    //                         style={{
    //                             marginBottom: 2
    //                         }}
    //                         placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
    //                         toggle={() => {
    //                             this.setState({
    //                                 ["detail" + thisId] : !this.state["detail" + thisId]
    //                             })
    //                         }}
    //                     >Detail</Tooltip>
    //                 </span>
    //             </Fragment>
    //         );
    //     }
    // }
  ]

  render() {
    return (
      <>
        <b>
          Data Terpilih : <Badge className="rounded-pill bg-success font-size-12"> {this.state.dataSelected.length} </Badge> dari total <Badge className="rounded-pill bg-warning font-size-12"> {this.state.totalRow} </Badge>
        </b>
        &nbsp;&nbsp;&nbsp;&nbsp;
        {
          (accessRole('create')) ?
            <Button
              color="primary"
              onClick={
                () => {
                  this.handleButtonProcess()
                }
              }
              disabled={this.state.dataSelected.length > 0 ? false : true}
            >Proses Data Terpilih</Button>
            : null
        }
        &nbsp;&nbsp;&nbsp;&nbsp;
        {
          (accessRole('create')) ?
            <Button
              color="success"
              onClick={
                () => {
                  this.handleButtonGenerate()
                }
              }
            >Generate Ulang Rekomendasi</Button>
            : null
        }
        &nbsp;&nbsp;&nbsp;&nbsp;
        {
          (accessRole('print')) ?
            <Button
              color="success"
              onClick={
                () => {
                  this.handleButtonExportUsulan()
                }
              }
            >Export Data Usulan</Button>
            : null
        }
        <hr />

        <MKIDatatable
          withNumber={true}
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState({
              loadingTable: true,
              filter: filter
            }, function () {
              this.setTokenAPI()
            });
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}

          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"

          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}

          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}

          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}

          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ?
          <Redirect to={"/kepegawaian/kgb.html?detail&uuid=" + this.state.detailUuid} />
          : null}
      </>
    )
  }

}

export default TableActiveComponent